import {createAllActions, createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'ENTITIES/DRAFTS';

// FETCH_POST_DRAFT
export const {
    action: fetchPostDraft,
    success: fetchPostDraftSuccess,
    failed: fetchPostDraftFailed,
} = createAllActions(
    `${domain}/FETCH_POST_DRAFT`,
    (postId: string, draft?: any) => ({postId, draft}),
    (postId: string, draft: any) => ({postId, draft}),
    (error: Error) => ({error}),
);

// FETCH_ALL
export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAllActions(
    `${domain}/FETCH_ALL`,
    (payload: {
        fetchPosts: boolean;
        fetchObservations: boolean;
        observationVariants: string[];
        childId: string | null;
    }) => payload,
    (drafts: any) => ({drafts}),
    (error: Error) => ({error}),
);

// CREATE
export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
} = createAllActions(
    `${domain}/CREATE`,
    (payload: {
        recipients: string;
        from: string;
        body: string;
        richTextBody: string;
        files: any;
        observationData: any;
        disableFeedback: boolean;
        activities: any;
        famlyLiveMeetingId: any;
        pollId: any;
    }) => payload,
    (payload: {draftId: string; draft: any}) => payload,
);

// UPDATE
export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAllActions(
    `${domain}/UPDATE`,
    (
        draftId: string,
        recipients: string,
        from: string,
        body: string,
        richTextBody: string,
        files: any,
        observationData: any,
        disableFeedback: boolean,
        pollId: any,
    ) => ({
        draftId,
        recipients,
        from,
        body,
        richTextBody,
        files,
        observationData,
        disableFeedback,
        pollId,
    }),
    (oldDraftId: string, newDraft: any) => ({oldDraftId, newDraft}),
    (draft: any) => ({draft}),
);

export const {action: updateAborted} = createAction(`${domain}/UPDATE_ABORTED`, (draftId: string) => ({draftId}));

// SEND
export const {
    action: send,
    success: sendSuccess,
    failed: sendFailed,
} = createAllActions(
    `${domain}/SEND`,
    (payload: {
        draftId: string;
        recipients: string;
        from: string;
        body: string;
        richTextBody: string;
        files: any;
        observationData: any;
        formIdentifier: string;
        disableFeedback: boolean;
    }) => payload,
    (draftId: string) => ({draftId}),
    (draftId: string) => ({draftId}),
);

export const {action: sendAborted} = createAction(`${domain}/SEND_ABORTED`, (draftId: string) => ({draftId}));

// REMOVE
export const {
    action: remove,
    success: removeSuccess,
    failed: removeFailed,
} = createAllActions(
    `${domain}/REMOVE`,
    (draft: any, extraData: any) => ({draft, extraData}),
    (draftId: string, extraData: any) => ({draftId, extraData}),
    (draft: any, extraData: any) => ({draft, extraData}),
);

export const {action: removeAborted} = createAction(`${domain}/REMOVE_ABORTED`, (draftId: string, extraData: any) => ({
    draftId,
    extraData,
}));
